import React from 'react';
import ReactDOM from 'react-dom/client';
import { SwedishPrivateForm } from './components/forms/swedish-private-form/swedish-private-form';
import './main.scss';
import { ProviderWithGlobalStore } from 'tradera/state/configure-store';
import { bootLanguages } from 'tradera/lang/boot-languages';
import { UserRegWrapper } from 'tradera/apps/registration/components/common/user-reg-wrapper';

bootLanguages();

const root = ReactDOM.createRoot(document.getElementById('app-form'));
root.render(
    <ProviderWithGlobalStore>
        <UserRegWrapper>
            <SwedishPrivateForm
                antiForgeryToken={window.injectAppProps.antiForgeryToken}
                appleAppId={window.injectAppProps.appleAppId}
                appleEnabled={window.injectAppProps.appleEnabled}
                autoFillFeatureEnabled={
                    window.injectAppProps.autoFillFeatureEnabled
                }
                facebookAppId={window.injectAppProps.facebookAppId}
                facebookEnabled={window.injectAppProps.facebookEnabled}
                googleAppId={window.injectAppProps.googleAppId}
                googleEnabled={window.injectAppProps.googleEnabled}
                klarnaAppId={window.injectAppProps.klarnaAppId}
                klarnaEnvironment={window.injectAppProps.klarnaEnvironment}
                klarnaEnabled={window.injectAppProps.klarnaEnabled}
                helpUrl={
                    'https://info.tradera.com/ovriga-problem-inloggning-kontakt/'
                }
                isHybridAppContext={window.injectAppProps.isHybridAppContext}
                isNativeAppContext={window.injectAppProps.isNativeAppContext}
                redirectLink={window.injectAppProps.redirectLink}
                url={'/api/register/swedish-private'}
            />
        </UserRegWrapper>
    </ProviderWithGlobalStore>
);
